import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 1,
  class: "modal-footer"
}
const _hoisted_7 = ["disabled"]

import { computed } from "vue";


export default {
  __name: 'BaseModal',
  props: {
	show: { type: Boolean, default: false },
	title: { type: String, default: "" },
	size: { type: String, default: "md" }, // sm, md, lg, xl
	showHeader: { type: Boolean, default: true },
	showFooter: { type: Boolean, default: true },
	cancelText: { type: String, default: "Schließen" },
	isLoading: { type: Boolean, default: false },
	modalId: { type: String, default: "modal" },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const modalSize = computed(() => {
	const sizeMap = {
		sm: "modal-sm",
		md: "",
		lg: "modal-lg",
		xl: "modal-xl",
	};
	return sizeMap[props.size] || "";
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal base-modal fade", { show: __props.show }]),
    style: _normalizeStyle({
      backdropFilter: __props.show ? 'brightness(0.5)' : 'none',
      display: __props.show ? 'block' : 'none',
    }),
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": `${__props.modalId}Label`,
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog", modalSize.value]),
      role: "document"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.showHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h5", {
                id: `${__props.modalId}Label`,
                class: "modal-title"
              }, [
                _renderSlot(_ctx.$slots, "title", {}, () => [
                  _createTextVNode(_toDisplayString(__props.title), 1 /* TEXT */)
                ])
              ], 8 /* PROPS */, _hoisted_4),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
              })
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "body")
        ]),
        (__props.showFooter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  disabled: __props.isLoading,
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('close')))
                }, _toDisplayString(__props.cancelText), 9 /* TEXT, PROPS */, _hoisted_7)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1))
}
}

}